module.exports = __webpack_public_path__ + "static/img/rule.6a8654a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/popup/rule.png
// module id = /a1x
// module chunks = 1